import _axios from '@/util/httpConfig.js'
// 获取图片picCode
export const getpicCode = (moduleCode) => {
  const data = {"appCode":"APPAFBB8CD316AFF62","moduleCode":moduleCode,"moduleNavCode":"","pageNo":1,"pageSize":999,"picName":"","picStatus":"","status":"","tenantCode":"96F307B9D0EDF9F","typeCode":""}
  return _axios('POST', '/common-content/contentPic/list','' ,data)
}
//获取首页背景图
export const getHomePic = (picCode,tenantCode) => {
  return _axios('GET', `common-content/contentPic/get?picCode=${picCode}&tenantCode=${tenantCode}`,'' ,{})
}
// 获取首页轮播图
export const getSwiper = () => {
  const data = {"appCode":"APPAFBB8CD316AFF62","moduleCode":"RES04AB063FA3130CC","moduleNavCode":"","pageNo":1,"pageSize":999,"picName":"","picStatus":"","status":"","tenantCode":"96F307B9D0EDF9F","typeCode":""}
  return _axios('POST', '/common-content/contentPic/list','' ,data)
}
// 获取首页主要业务图片
export const getIndex = () => {
  const data = {"appCode":"APPAFBB8CD316AFF62","moduleCode":"RES000737451A92C44","moduleNavCode":"","pageNo":1,"pageSize":999,"picName":"","picStatus":"","status":"","tenantCode":"96F307B9D0EDF9F","typeCode":""}
  return _axios('POST', '/common-content/contentPic/list','' ,data)
}
// 获取轮播图详情
export const getSwipeDetail = (picCode, tenantCode) => {
  return _axios('GET', `/common-content/contentPic/get?picCode=${picCode}&tenantCode=${tenantCode}`,'' ,{})
}
// 获取通知公告
export const getAnnounce = (page = 1, pagesize = 4, moduleCode='RES43BCD5C2BBB0C3E', type="contentNews", typeCode='') => {
  const data = {"appCode":"APPAFBB8CD316AFF62","contentStatus":"","contentTitle":"","moduleCode":moduleCode,"moduleNavCode":"","pageNo":page,"pageSize": pagesize,"status":"","tenantCode":"96F307B9D0EDF9F","typeCode":typeCode}
  return _axios('POST', `/common-content/${type}/list`,'' ,data)
}
// 获取工作状态
export const getWork = () => {
  const data = {"appCode":"APPAFBB8CD316AFF62","contentStatus":"","contentTitle":"","moduleCode":"RES5506AC06727CBE9","moduleNavCode":"","pageNo":0,"pageSize":4,"status":"","tenantCode":"96F307B9D0EDF9F","typeCode":""}
  return _axios('POST', '/common-content/contentNews/list','' ,data)
}
// 获取人事招聘
export const getRecruitment = () => {
  const data = {"appCode":"APPAFBB8CD316AFF62","contentStatus":"","contentTitle":"","moduleCode":"RESD00863695DD1543","moduleNavCode":"","pageNo":0,"pageSize":4,"status":"","tenantCode":"96F307B9D0EDF9F","typeCode":""}
  return _axios('POST', '/common-content/contentNews/list','' ,data)
}
// 获取标题
export const getInfoTitle = () => {
  const data = {
    appCode: "APPAFBB8CD316AFF62",
    moduleName: "",
    pageNo: 0,
    pageSize: 1000,
    parentResourceCode: "RES1EF57E5C6817A75",
    resourceName: "",
    status: "E",
    tenantCode: "96F307B9D0EDF9F"
  }
  return _axios('POST', '/common-content/contentModule/list', '', data)
}


// WEBPACK FOOTER //
// ./src/api/homeIndex.js